exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".case-detail-title[data-v-5a977ad0]{font-weight:bolder;font-size:20px;color:#2d8cf0;margin-bottom:24px}.case-detail-form-item[data-v-5a977ad0]{width:100%;display:inline-block;padding-right:2%}.case-detail-material-img[data-v-5a977ad0]{width:120px;height:120px;border:4px solid #42c2f3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a977ad0","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/caseDetail/Sample.vue
// module id = JE2l
// module chunks = 2